import { render, staticRenderFns } from "./CmgClearWalletModal.vue?vue&type=template&id=a48a7bd8&scoped=true&lang=pug"
import script from "./cmg-clear-wallet-modal.ts?vue&type=script&lang=ts&external"
export * from "./cmg-clear-wallet-modal.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgClearWalletModal.vue?vue&type=style&index=0&id=a48a7bd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a48a7bd8",
  null
  
)

export default component.exports